import React, { FC } from 'react'

import styled from 'styled-components'

import { Txt } from 'src/components/atoms'

const Row = styled.div<{ heightRem?: number }>`
  display: flex;
  align-items: center;
  height: ${({ heightRem }) => (heightRem ? `${heightRem}rem` : '1.79rem')};
`

const ItemTitleWrapper = styled.div`
  width: 8.93rem;
  flex-shrink: 0;
`

type Props = {
  title: string
  heightRem?: number
  children: React.ReactNode
  className?: string
}

export const UserDetailBasicInfoContentItem: FC<Props> = ({
  title,
  heightRem,
  children,
  className,
}) => {
  return (
    <div className={className}>
      <Row heightRem={heightRem}>
        <ItemTitleWrapper>
          <Txt className="tw-text-standardText-secondary">{title}</Txt>
        </ItemTitleWrapper>
        {children}
      </Row>
    </div>
  )
}
